import {
	type Jast,
	type TerminalClause,
	JastBuilder,
	CLAUSE_TYPE_COMPOUND,
	CLAUSE_TYPE_TERMINAL,
} from '@atlaskit/jql-ast';

export const getClauses = (jql: string, fieldIdentifier: string): Array<TerminalClause> => {
	const ast: Jast = new JastBuilder().build(jql);

	const fieldsToReturn: Array<TerminalClause> = [];
	if (ast && ast.query && ast.query.where) {
		if (ast.query.where.clauseType === CLAUSE_TYPE_COMPOUND) {
			ast.query.where.clauses.forEach((clause) => {
				if (clause.clauseType === CLAUSE_TYPE_TERMINAL) {
					const fieldId = clause.field.value.toLowerCase();
					if (fieldIdentifier.toLowerCase() === fieldId) {
						fieldsToReturn.push(clause);
					}
				}
			});
		} else if (ast.query.where.clauseType === CLAUSE_TYPE_TERMINAL) {
			const fieldId = ast.query.where.field.value.toLowerCase();
			if (fieldIdentifier.toLowerCase() === fieldId) {
				if (ast.query && ast.query.where) fieldsToReturn.push(ast.query.where);
			}
		}
	}
	return fieldsToReturn;
};

export const removeSurroundingQuotes = (maybeQuotedString: string): string =>
	maybeQuotedString.replace(/^["']|["']$/g, '');
